export default __webpack_public_path__ + "static/door-fb4d47cacee1b253a17442ef81ea9a40.webp";